import { render } from "./BotonComprobanteSiiafEmbargoPersonaComponent.vue?vue&type=template&id=4bba4db4"
import script from "./BotonComprobanteSiiafEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonComprobanteSiiafEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__